var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgModuleToolkit = function SvgModuleToolkit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2018.74,
    height: 2048,
    viewBox: "0 0 2018.743 2048"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 51.6,
    d: "M794.537 1761.294c50.625 0 91.48-41.744 92.37-91.481v-586.186c0-50.625-40.857-92.368-92.37-92.368H208.351c-50.625 0-92.369 40.855-92.369 92.368v585.298c0 50.625 40.856 92.369 92.37 92.369zM794.537 869.658c50.625 0 91.48-41.744 92.37-91.481V191.991c0-50.625-40.857-92.368-92.37-92.368H208.351c-50.625 0-92.369 40.855-92.369 92.368v585.298c0 50.625 40.856 92.369 92.37 92.369zM1713.723 869.658c50.625 0 91.481-41.744 92.37-91.481V191.991c0-50.625-40.856-92.368-92.37-92.368h-586.186c-50.625 0-92.368 40.855-92.368 92.368v585.298c0 50.625 40.855 92.369 92.368 92.369z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m1961.982 1947.302-273.439-273.439-36.404 36.404 273.44 273.439z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1924.946 1983.226c9.953 9.953 26.168 9.852 36.246-.226s10.18-26.293.226-36.246z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 52.07,
    d: "M1442.152 1785.834c212.323-17.036 370.413-202.707 353.377-415.031-17.035-212.323-202.707-370.414-415.03-353.378-212.324 17.036-370.414 202.708-353.378 415.031 17.036 212.324 202.707 370.414 415.031 353.378Z"
  })));
};
export default SvgModuleToolkit;